import { api } from "./api";

const fetchRule = async():Promise<any> =>{
    try{
        const query = [{
            $match:{}
        }]
        const {data} = await api.post('/database/regulation__c/aggregate',query)
    
        if(!Array.isArray(data)){
            return [];
        }else{
            return data[0];
        }
    }catch(error:any){
        throw error;
    }
}

export {
    fetchRule
}